import { useMutation, useQueryClient } from "@tanstack/react-query";

import { evaluationCriteriaKeys } from "@/application/query-keys/evaluation-criteria.keys";
import {
  evaluationCriteriaRepository,
  type UpsertCriterionInput,
} from "@/infrastructure/repositories/evaluation-criteria.supabase.repository";

export function useUpsertCriterion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: UpsertCriterionInput) => evaluationCriteriaRepository.upsert(input),
    onSettled: () => {
      void qc.invalidateQueries({ queryKey: evaluationCriteriaKeys.all });
    },
  });
}

export function useRemoveCriterion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => evaluationCriteriaRepository.remove(id),
    onSettled: () => {
      void qc.invalidateQueries({ queryKey: evaluationCriteriaKeys.all });
    },
  });
}
